/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_No_Amendment_PendingInputs */

const en_orders_no_amendment_pending = /** @type {(inputs: Orders_No_Amendment_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No amendment-pending on-hold orders.`)
};

const es_orders_no_amendment_pending = /** @type {(inputs: Orders_No_Amendment_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay pedidos en espera con enmienda pendiente.`)
};

/**
* | output |
* | --- |
* | "No amendment-pending on-hold orders." |
*
* @param {Orders_No_Amendment_PendingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_no_amendment_pending = /** @type {((inputs?: Orders_No_Amendment_PendingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_No_Amendment_PendingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_no_amendment_pending(inputs)
	return es_orders_no_amendment_pending(inputs)
});